import React from "react";
import { Box } from "rebass/styled-components";

export default function Subheader(props) {
  return (
    <Box variant="text.subheader" {...props}>
      {props.children}
    </Box>
  );
}
